import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";

const SuggesstAlternative = (props) => {

    const { run, input, writeBackInsert, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: `Write one alternative version of the following text with the same intent.\n\nTEXT:\n${input}`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackInsert(asText(r)))
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex items-center justify-center p-4 gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default SuggesstAlternative;
